<div class="d-flex w-full h-full">
  <mat-card class="m-auto" style="max-width: 380px;">
    <mat-card-header class="m-b-24">
      <mat-card-title-group>
        <mat-card-title>Регистрация</mat-card-title>
        <img routerLink="/catalog" style="border-radius:80px;max-width: 80px;max-height: 80px"
             src="assets/images/pro_mobile_service.jpg">
      </mat-card-title-group>
    </mat-card-header>

    <mat-card-content>
      <form class="form-field-full" [formGroup]="registerForm">
        <mat-form-field appearance="outline">
          <mat-label>Имя</mat-label>
          <input matInput formControlName="name" required>
          @if (registerForm.get('name')?.invalid) {
          <mat-error>
            <span>Заполните</span>
          </mat-error>
          }
        </mat-form-field>


        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" required>
          @if (registerForm.get('username')?.invalid) {
          <mat-error>
            <span>Заполните</span>
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Телефон</mat-label>
          <span style="margin-left: 16px" matPrefix>+7</span>
          <input type="text" mask="000 000 00 00" matInput placeholder="777 777 77 77" required formControlName="phone">
          @if (registerForm.get('phone')?.invalid) {
          <mat-error>
            <span>Заполните</span>
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Пароль</mat-label>
          <input matInput type="password" formControlName="password" required>
          @if (registerForm.get('password')?.invalid) {
          <mat-error>
            <span>Заполните</span>
          </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Повторите пароль</mat-label>
          <input matInput type="password" formControlName="confirmPassword" required>
          @if (registerForm.get('confirmPassword')?.hasError('required')) {
          <mat-error>
            <span>Заполните</span>
          </mat-error>
          }
          @if (registerForm.get('confirmPassword')?.hasError('mismatch')) {
          <mat-error
            translate [translateParams]="{value: 'login.password' | translate}">
              <span>Пароли не совпадают</span>
            </mat-error>
          }
        </mat-form-field>


        <button [loading]="isLoading" class="w-full m-y-16" mat-raised-button color="primary" (click)="register()">Создать аккаунт</button>

        <div>У меня есть аккаунт
          <a routerLink="/auth/login">Войти</a>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
